// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js!../../../css/ANewDialog.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, "#dialog-overlay.ModuleGroup-new-dialog .dialog-container{\r\n    height: 100%;\r\n    width: 800px;\r\n}", ""]);
// Exports
module.exports = exports;
